<template>
  <div class="search">
    <Head :Index="isIndex"/>
    <div class="banner">
      <div class="pc-banner"><img src="@/assets/vlovemother-banner-pc.jpg"></div>
      <div class="wap-banner"><img src="@/assets/vlovemother-banner-wap.jpg"></div>
    </div>
    <div class="auto_1280">
      <div class="tips" v-if="isEmpty && lan === 0">搜索结果为空</div>
      <div class="tips" v-if="isEmpty && lan === 1">The search result is empty</div>
      <ul class="ul result">
        <li v-for="( item, index ) in searchList" :key="index" @click="linkTo(item)">
          <div class="content clearfix">
            <div class="title dot">{{item.title}}</div>
            <div class="date">{{item.createTime | format}}</div>
          </div>
        </li>
      </ul>
      <div class="pager" v-if="!isEmpty">
        <span class="p_page">
          <a @click="pageIndex = ( pageIndex == 1 ? 1 : pageIndex - 1 );" class="a_prev" :class="{disable_prev: pageIndex == 1}"></a>
          <em class="num">
            <template v-for="( num, index ) in pageList">
              <a @click="pageIndex = num;" :key="index" :class="[ num == pageIndex ? 'a_cur' : '' ]">{{num}}</a>
            </template>
          </em>
          <a @click="pageIndex = ( pageIndex == maxPageIndex ? maxPageIndex : pageIndex + 1 );" class="a_next" :class="{disable_next: pageIndex == maxPageIndex}"></a>
        </span>
      </div>
    </div>
    <Bottom :Index="isIndex"/>
  </div>
</template>
<script>
import Head from '@/components/header'
import Bottom from '@/components/bottom'
export default {
  name: 'Search',
  components: {
    Head,
    Bottom
  },
  filters: {
    format (value) {
      const date = new Date(value)
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const sdate = ('0' + date.getDate()).slice(-2)
      const result = year + '.' + month + '.' + sdate
      return result
    }
  },
  data () {
    return {
      search: '',
      searchList: [],
      isIndex: false,
      menuList: [],

      isEmpty: false,
      pageList: [],
      pageIndex: 1,
      pageSize: 8,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn
    }
  },
  watch: {
    $route () {
      this.search = this.$route.query.search
      this.init()
    },
    pageIndex (val, oldval) {
      if (val !== oldval) {
        this.init()
      }
    },
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      if (this.pageIndex !== 1) {
        this.pageIndex = 1
      } else {
        this.init()
      }
    }
  },
  mounted () {
    const self = this
    self.search = self.$route.query.search
    this.$api.post('api/benefitArticleType/queryByParam', { current: 1, pageSize: 40, bLanguage: this.lan }, r => {
      const menuList = []
      for (let i = 0; i < r.data.length; i++) {
        let id
        if (r.data[i].parentId === 0) {
          menuList.push(r.data[i])
          id = r.data[i].id
          const children = []
          for (let j = 0; j < r.data.length; j++) {
            if (r.data[j].parentId === id) {
              children.push(r.data[j])
            }
          }
          menuList[menuList.length - 1].children = children
        }
      }
      this.menuList = menuList
      this.init()
    })
  },
  methods: {
    init () {
      const self = this
      self.searchList = []
      self.$api.post('api/benefitArticle/searchByParam', { content: self.search, current: self.pageIndex, pageSize: self.pageSize, bLanguage: this.lan }, r => {
        if (r.total === 0 || typeof (r.total) === 'undefined') {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        self.total = r.total
        if (r.data) {
          r.data.forEach((item) => {
            this.searchList.push(item)
          })
        }
        self.initPager()
      })
      self.$nextTick(function () {
        self.initEL()
      })
    },
    initPager () {
      const self = this
      const footerCount = 5
      self.pageList = []
      self.maxPageIndex = parseInt(self.total / self.pageSize) + (self.total % self.pageSize === 0 ? 0 : 1)
      let startPageIndex = self.pageIndex - parseInt(footerCount / 2)
      startPageIndex = startPageIndex < 1 ? 1 : startPageIndex
      for (let i = startPageIndex; i <= self.maxPageIndex; i++) {
        self.pageList.push(i)
        if (self.pageList.length >= footerCount) break
      }
    },
    initEL () {},
    linkTo (item) {
      // 搜索结果跳转逻辑
      let name
      let path
      let id
      // 获取当前栏目id和所属父栏目id
      if (item.articleTypeParentId === 0) {
        id = item.articleTypeId
      } else {
        id = item.articleTypeParentId
      }
      let route
      try {
        route = JSON.parse(localStorage.getItem('routeList'))
      } catch (e) {
        console.log(e)
      }
      route.forEach((list) => {
        if (list.id === item.articleTypeId) {
          name = list.requestTo.toLowerCase()
          path = list.requestTo.toLowerCase()
        }
        list.children.forEach((inner) => {
          if (inner.id === item.articleTypeId) {
            name = list.requestTo.toLowerCase()
            path = inner.requestTo.toLowerCase()
          }
        })
      })
      localStorage.setItem('path', path)
      localStorage.setItem('columnId', id)
      // 有详情页的跳转到详情页
      if (item.articleTypeId === 17 || item.articleTypeParentId === 4 || item.video !== '' || (item.articleTypeId === 8 && item.tag === '') || (item.articleTypeId === 12 && item.tag === '') || (item.articleTypeId === 11 && item.tag === '') || (item.articleTypeId === 10 && item.tag === '')) {
        this.$router.push({
          path: '/' + name + '/detail',
          query: {
            columnId: item.articleTypeParentId,
            articleTypeId: item.articleTypeId,
            id: item.id
          }
        })
      } else if (item.articleTypeParentId === 0 && item.articleTypeId === 1 && item.video === '') {
        // 视频结果跳转到唯爱妈妈页面
        this.$router.push({
          path: '/vlovemother',
          query: {
            columnId: item.articleTypeId
          }
        })
      } else if (item.articleTypeId === 18 || item.articleTypeId === 46) {
        // 审计报告和公开文档点击预览pdf文件
        window.open(item.content, '_blank')
      } else {
        // 其他跳转到对应页面
        this.$router.push({
          path: '/' + name + '/' + path,
          query: {
            columnId: id
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.banner .pc-banner{position: relative;}
.banner .wap-banner{display: none;}
.banner .content{position: absolute; top: 0; left: 0; width: 100%; height: 100%;}
.banner .title{font-size: 48px; color: #fff;}
.banner .txt{font-size: 18px; color: #fff; font-weight: lighter; padding-top: 1%; letter-spacing: 4px;}
@media(max-width: 1024px){
  .banner .pc-banner{display: none;}
  .banner .wap-banner{display: block;}
}
.search .result{padding: 5% 0;}
.search .tips{text-align: center; padding: 5% 0; font-size: 50px; color: #e4007f; font-weight: bold;}
.search .result li{width: 100%; line-height: 60px; border: 3px solid #e4007f; color: #e4007f; font-size: 20px; border-radius: 20px 0; margin-bottom: 2%; padding: 0 3%; position: relative; transition: all .3s; cursor: pointer;}
.search .result .title{float: left; width: 80%; min-height: 60px;}
.search .result .date{position: absolute; right: 3%; top: 0;}
.search .result li:hover{color: #fff; background-color: #e4007f;}
.search .pager{padding-bottom: 5%;}
@media(max-width: 768px){
  .search .tips{font-size: 28px;}
  .search .result li{font-size: 16px;}
}
</style>
